import * as React from "react";
function SvgMagicWandGradient(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M5.563 3.794l1.524.853-.854-1.523.854-1.524-1.524.853L4.039 1.6l.854 1.524-.854 1.523 1.524-.853zm7.314 5.973l-1.524-.854.853 1.524-.853 1.524 1.524-.854 1.523.854-.853-1.524.853-1.524-1.524.854zM14.4 1.6l-1.524.853-1.523-.853.853 1.524-.853 1.523 1.524-.853 1.523.853-.853-1.523L14.4 1.6zM9.75 4.824a.607.607 0 00-.86 0l-7.112 7.112a.607.607 0 000 .86l1.426 1.426a.607.607 0 00.86 0l7.106-7.106a.607.607 0 000-.86L9.75 4.824zM9.122 8.17L7.83 6.878 9.317 5.39l1.292 1.292L9.122 8.17z"
        fill="url(#magic-wand-gradient_svg__magic-wand-gradient)"
      />
      <defs>
        <linearGradient
          id="magic-wand-gradient_svg__magic-wand-gradient"
          x1={1.6}
          y1={14.389}
          x2={14.4}
          y2={14.388}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B627A1" />
          <stop offset={1} stopColor="#1D9F9F" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgMagicWandGradient);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
